<style scoped>
.checkin {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  box-sizing: border-box;
  background: #f4f7fc;
}
.checkin_title {
  font-size: 14px;
  color: #b2b2b2;
  margin-bottom: 16px;
}
.checkin_title span {
  color: #5c5c5c;
}
.checkin_information {
  width: 100%;
  flex: 1;
  background: white;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
  box-sizing: border-box;
}
.checkin_information::-webkit-scrollbar {
  display: none;
}
.checkin_information_t {
  font-size: 16px;
  color: #1a1a1a;
  margin-bottom: 24px;
}
.member_header {
  width: 100%;
  height: 76px;
  border-bottom: 1px solid #cfd4e8;
  display: flex;
  align-items: center;
  padding: 0 19px;
  box-sizing: border-box;
  justify-content: flex-end;
}
.member_header_bto {
  cursor: pointer;
  height: 36px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  margin-left: 6px;
  text-align: center;
  padding: 0 12px;
  box-sizing: border-box;
  line-height: 36px;
  font-size: 14px;
  color: #7e84a3;
}
.member_content {
  display: flex;
  flex: 1;
  width: 100%;
}
.member_content_l {
  width: 330px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 0 10px;
  border-right: 1px solid #cfd4e8;
  box-sizing: border-box;
}
.member_content_search {
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
  margin-bottom: 10px;
}
.de_search_name {
  width: 290px !important;
  margin-right: 10px;
}

.de_search {
  width: 243px;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
}
::v-deep .member_content_search .el-select {
  width: 140px;
  margin-bottom: 16px;
}
.member_content_device {
  width: 100%;
  flex: 1;
  max-height: calc(100vh - 20rem);
  overflow-y: scroll;
}
.member_content_d {
  width: 100%;
  height: 48px;
  padding: 0 10px 0 20px;
  /*line-height: 48px;*/
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #5c5c5c;
  font-size: 16px;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.member_content_r {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 33px 0 44px;
  box-sizing: border-box;
}
.member_content_r_search {
  width: 100%;
  height: 86px;
  display: flex;
  padding-top: 20px;
  box-sizing: border-box;
}
::v-deep .member_content_r_search .el-select {
  width: 137px;
  margin: 0 12px;
}
::v-deep .member_content_r_search .el-input__icon {
  height: auto;
}
::v-deep .member_content_r_search .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 137px;
  height: 36px;
  margin-right: 12px;
}
.memeber_table {
  width: 100%;
  flex: 1;
  position: relative;
}

::v-deep .available_search .el-input__inner {
  height: 100%;
  border: none;
}

.available_depa_left_icon img {
  width: 18px;
  height: 18px;
}
.available_depa_left_icon2 img {
  width: 18px;
  height: 18px;
}

::v-deep .available_frame_tobeselected_top .el-checkbox__label {
  font-size: 14px;
  color: rgba(26, 26, 26, 0.6);
  font-weight: normal;
}

::v-deep .workhour_time .el-form-item__content {
  line-height: normal;
}

::v-deep .available_search .el-select {
  width: 120px;
  border-right: 1px solid #d0d0d0;
}
.newpagination {
  height: 50px;
  margin-top: 10px;
}
.member_content_d_select {
  background: #f2f7ff;
}
</style>

<template>
  <div class="checkin">
    <div class="checkin_title">设备管理 / <span>区域管理</span></div>
    <div class="checkin_information">
      <div class="member_header">
        <el-button type="primary" plain style="margin-right: 10px;" :disabled="!deviceQuerySearch.spaceId" @click="handleAddDevice">添加区域设备</el-button>
        <el-popconfirm
            title="是否确认删除设备？"
            @confirm="batchDeleteSpaceDevice()"
        >
          <el-button :disabled="!deviceQuerySearch.spaceId"
              type="danger" plain slot="reference">
            删除区域设备
          </el-button>
        </el-popconfirm>
<!--        <div class="member_header_bto" @click="handleAddDevice">
          添加区域设备
        </div>
        <div class="member_header_bto">
          <el-popconfirm
              title="是否确认删除设备？"
              @confirm="batchDeleteSpaceDevice()"
          >
            <el-button
                type="text" slot="reference">
              删除区域设备
            </el-button>
          </el-popconfirm>
        </div>-->
      </div>
      <div class="member_content">
        <div class="member_content_l">
          <div class="member_content_search">
              <el-input
                  v-model="searchQuery.name"
                  clearable
                  @keyup.enter.native="getSpaceList"
                  placeholder="搜索区域名称"
              >
                <i slot="suffix" style="font-size: 14px;cursor: pointer;" class="el-input__icon el-icon-search" @click="getSpaceList"></i>
              </el-input>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                <svg t="1770435353697" class="icon" style="cursor: pointer;margin-top: 4px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="56588" width="22" height="22"><path d="M512 298.6496a85.3504 85.3504 0 1 0 0-170.6496 85.3504 85.3504 0 0 0 0 170.6496z" fill="#2c2c2c" p-id="56589"></path><path d="M512 512m-85.3504 0a85.3504 85.3504 0 1 0 170.7008 0 85.3504 85.3504 0 1 0-170.7008 0Z" fill="#2c2c2c" p-id="56590"></path><path d="M512 896a85.3504 85.3504 0 1 0 0-170.7008 85.3504 85.3504 0 0 0 0 170.7008z" fill="#2c2c2c" p-id="56591"></path></svg>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{command: 1, row: null}">创建区域</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="member_content_device">
            <div
                v-for="item in spaceList"
                :class="[
                'member_content_d',
                deviceQuerySearch.spaceId == item.id ? 'member_content_d_select' : ''
              ]"
                @click="handleChangeSpace(item.id)"
            >
              <span>{{ item.name }}</span>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <svg t="1770435353697" class="icon" style="cursor: pointer;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="56588" width="20" height="20"><path d="M512 298.6496a85.3504 85.3504 0 1 0 0-170.6496 85.3504 85.3504 0 0 0 0 170.6496z" fill="#2c2c2c" p-id="56589"></path><path d="M512 512m-85.3504 0a85.3504 85.3504 0 1 0 170.7008 0 85.3504 85.3504 0 1 0-170.7008 0Z" fill="#2c2c2c" p-id="56590"></path><path d="M512 896a85.3504 85.3504 0 1 0 0-170.7008 85.3504 85.3504 0 0 0 0 170.7008z" fill="#2c2c2c" p-id="56591"></path></svg>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{command: 1, row: item}">编辑区域</el-dropdown-item>
                  <el-dropdown-item :command="{command: 2, row: item}"><span style="color:#F56C6C">删除区域</span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="newpagination" style="width: 100%; text-align: center;display: block" v-if="spaceTotal > 0">
            <el-pagination
                :hide-on-single-page="true"
                layout="prev, pager, next"
                :total="spaceTotal"
                :current-page="searchQuery.pageNum"
                :page-size="30"
                :page-count="3"
                @current-change="handleChangeSpacePage"
            >
            </el-pagination>
          </div>
        </div>
        <div class="member_content_r">
          <div class="member_content_r_search">
            <div class="de_search_name de_search">
              <el-tooltip
                  effect="dark"
                  content="设备名称、云序列号"
                  placement="top-start"
              >
                <el-input
                    v-model="deviceQuerySearch.likeString"
                    placeholder="设备名称、云序列号"
                    class="department_search_inp"
                    style="width: 200px"
                ></el-input>
              </el-tooltip>
            </div>
            <div>
              <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;">搜索</el-button>
            </div>

          </div>
          <div class="memeber_table">
            <el-table ref="multipleTable"
                      :data="deviceList"
                      :header-cell-style="{
                        background: '#F5F6FA',
                        color: '#5C5C5C',
                      }"
                      height="540"
                      width="100%"
                      class="device_table common_text common_t"
                      @selection-change="handleSelectionChange">
              <template slot="empty">
                <div>
                  <img src="@/assets/nodata.png" class="nodata" />
                  <div class="nodata_text">无数据</div>
                </div>
              </template>
              <el-table-column type="selection" header-align="center" align="center" width="50" fixed="left">
              </el-table-column>
              <el-table-column prop="name" label="设备名称" align="left" fixed="left">
              </el-table-column>
              <el-table-column prop="sn" label="云序列号" align="left" fixed="left" min-width="130">
              </el-table-column>
              <el-table-column prop="status" label="设备状态" align="left" fixed="left" width="120">
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.status == 1" class="d_forbidden">在线</div>
                    <div v-else class="d_start_using">离线</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="设备用途">
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.equipmentUsageType == 1" >考勤</div>
                    <div v-else-if="scope.row.equipmentUsageType == 2" >门禁</div>
                    <div v-else-if="scope.row.equipmentUsageType == 3" >考勤+门禁</div>
                    <div v-else>--</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="设备类型" align="left" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.type == 0">指纹系列考勤机</div>
                  <div v-if="scope.row.type == 1">近红外人脸考勤机</div>
                  <div v-if="scope.row.type == 2">动态人脸考勤机</div>
                  <div v-if="scope.row.type == 3">近红外人脸门禁机</div>
                  <div v-if="scope.row.type == 4">动态人脸门禁机</div>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center" width="80" fixed="right">
                <template slot-scope="scope">

                  <el-popconfirm
                      title="是否确认删除该设备？"
                      @confirm="deleteSpaceDevice(scope.row)"
                  >
                    <el-button
                        type="text" slot="reference"
                        style="color: #f56c6c;">
                      删除
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="newpagination" v-if="deviceTotal > 0">
            <div class="newpagination_text">共 {{ deviceTotal }} 条数据</div>
            <el-pagination
                layout="prev, pager, next"
                :total="deviceTotal"
                :current-page="deviceQuerySearch.pageNum"
                :page-size="20"
                @current-change="handleChangeDevice"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <company-footer-info />

    <save-space ref="saveSpace" @success="getSpaceList"/>
    <device-select-dialog :local="true" :devices="notAllotDeviceList" ref="deviceSelectRef" @confirm="handleSelectDevice"/>
  </div>
</template>


<script>
import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
import { SpaceApi } from '@/api/server/space';
import SaveSpace from "@/views/space/components/save-space.vue";
import DeviceSelectDialog from "@/views/device/components/device-select-dialog.vue";
export default {
  components: { DeviceSelectDialog, CompanyFooterInfo,SaveSpace},
  data() {
    return {
      spaceId: null,
      spaceList: [],
      searchQuery: {
        name: null,
        pageNum: 1,
        pageSize: 30
      },
      spaceTotal: 0,
      deviceQuerySearch: {
        likeString: null,
        spaceId: null,
        pageNum: 1,
        pageSize: 20
      },
      deviceList: [],
      deviceTotal: 0,
      notAllotDeviceList: [],
      selectedDeviceList: []
    };
  },
  created() {

  },
  mounted() {
    this.getSpaceList();
  },
  methods: {
    getSpaceDmsDevicePage(){
      SpaceApi.getSpaceDmsDevicePage(this.deviceQuerySearch).then(res => {
        if (res.code == 200) {
          this.deviceList = res.data.list;
          this.deviceTotal = res.data.total;
        }
      });
    },
    async getNotAllotDmsDeviceList(){
      const response = await SpaceApi.getNotAllotDmsDeviceList(this.deviceQuerySearch);
      if (response.code == 200) {
        this.notAllotDeviceList = response.data;
      }
    },
    handleSaveSpace(row) {
      this.$refs.saveSpace.show(row);
    },
    handleCommand(command){
      switch (command.command){
        case 1:
          this.handleSaveSpace(command.row);
          break;
        case 2:
          this.handleDeleteSpace(command.row.id);
          break;
      }
    },
    getSpaceList() {
      SpaceApi.getSpaceList(this.searchQuery).then(res => {
        if (res.code == 200) {
          this.spaceList = res.data.list;
          this.spaceTotal = res.data.total;
          this.handleChangeSpace(this.spaceList[0]?.id || null);
        }
      });
    },
    handleChangeSpace(id){
      this.deviceQuerySearch.spaceId = id;
      this.getSpaceDmsDevicePage();
    },
    async handleAddDevice(){
      await this.getNotAllotDmsDeviceList();
      this.$refs.deviceSelectRef.show();
    },
    async handleDeleteSpace(spaceId){
      await this.$confirm('是否确认删除该空间？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        SpaceApi.deleteById(spaceId).then(response => {
          if (response.code == 200) {
            this.$message.success('删除成功');
            this.getSpaceList();
          }else {
            this.$message.error(response.message || '删除失败');
          }
        })
      })
    },
    handleSelectDevice(data){
      if(data && data.length > 0){
        SpaceApi.allotDevice({deviceIds:data.map(d=>d.id),id:this.deviceQuerySearch.spaceId}).then(response => {
          if (response.code == 200) {
            this.$message.success('添加成功');
            this.getSpaceDmsDevicePage();
          }else {
            this.$message.error(response.message || '添加失败');
          }
        })
      }else {
        this.$message.error('请选择设备');
      }

    },
    deleteSpaceDevice(row){
      SpaceApi.deleteDevice({id: this.deviceQuerySearch.spaceId, deviceIds: [row.id]}).then(response => {
        if (response.code == 200) {
          this.$message.success('删除成功');
          this.getSpaceDmsDevicePage();
        }else {
          this.$message.error(response.message || '删除失败');
        }
      })
    },
    batchDeleteSpaceDevice(){
      if(this.selectedDeviceList && this.selectedDeviceList.length>0){
        SpaceApi.deleteDevice({id: this.deviceQuerySearch.spaceId, deviceIds: this.selectedDeviceList.map(d=>d.id)}).then(response => {
          if (response.code == 200) {
            this.$message.success('删除成功');
            this.getSpaceDmsDevicePage();
          }else {
            this.$message.error(response.message || '删除失败');
          }
        })
      }else {
        this.$message.error('请选择设备');
      }
    },
    handleChangeSpacePage(val){
      this.searchQuery.pageNum = val;
      this.getSpaceList();
    },
    handleChangeDevice(val){
      this.deviceQuerySearch.pageNum = val;
      this.getSpaceDmsDevicePage();
    },
    handleSelectionChange(val){
      console.info('val__',val);
      this.selectedDeviceList = val;
    }
  }
};
</script>